import ApiService from '@common/lib/api/api.service';

export const clickBanner = params => {
  const payload = new FormData();
  for (const key in params) {
    payload.append(key, params[key]);
  }
  return ApiService.post(`banner/click`, payload);
};
